<template>
	<div class="">
		<!-- 以现有设备添加终端模板 新增终端模板 -->
				
		<el-form>
	        	
			<el-form-item label="模板名称" :label-width="formLabelWidth">
				<el-input v-model="template_name" auto-complete="off"></el-input>
			</el-form-item>
			<br />
			<el-form-item class="text-right">
				<el-button @click="cancelSetModel()">取消</el-button>
				<el-button v-if="device_id" type="primary" @click="setModel()">确定</el-button>
				<el-button v-if="!device_id" type="primary" @click="addModel()">确定</el-button>
			</el-form-item>
		</el-form>

	</div>
</template>

<script>
	export default {
		mounted() {

		},
		props:['device_id'],
    	data(){
    		return{
				template_name: "",
				formLabelWidth: "90px",
				mydevice_id: this.device_id || 0
    		}
		},		
    	methods:{
			//获取终端类别
    		setModel(){
    			let valiCodeParams={
					uid:this.getCookie('uid'),
					device_id: this.mydevice_id || 99999,
					template_name: this.template_name || "无名",
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/TemplateManage/AddTemplateByMount",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200){
						this.$message.success(res.data.msg,2000);
						this.cancelSetModel();
						this.template_name = "";
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg,2000);
		        	}
		  		});
			},
			// 新增模板
			addModel(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					template_name: this.template_name || "无名",
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/TemplateManage/AddTemplate",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200){
						this.$message.success(res.data.msg,2000);
						// 新增模板跳转增加终端
						let routeUrl = this.$router.resolve({
							path: "/device/terminalModelDevice",
							query: {
								id: res.data.data.template_id,
								template_name: res.data.data.template_name
							}
						});
						window.open(routeUrl.href, '_blank');
						// 添加成功后，关闭弹框，清空模板名称
						this.cancelSetModel();
						this.template_name = "";
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg,2000);
		        	}
		  		});
			},
			// 子传父通讯
			cancelSetModel(){
				this.$emit('setByValue', false)
			},
    		
    	
    	}
   }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/comss/setTerminalModel.vue